import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function PainPoints() {
  const points = ['Comés sano, buscás respuestas y seguís igual. Nadie te dio el mapa completo de tu intestino.', 'Tus estudios salen "normales", pero las soluciones que probás son parches que duran apenas unos días.', 'Hinchazón, pesadez y niebla mental. Tu médico los trata como problemas separados, pero son señales de lo mismo.', 'Tu vida social está condicionada por tu panza. Ya no decidís vos qué comer, tu inflamación decide por vos.'];
  return <section className="py-24 bg-brand-black relative overflow-hidden" data-id="element-155">
      {/* Subtle background element */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-red-900/5 to-transparent pointer-events-none" data-id="element-156" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-157">
        <div className="max-w-4xl mx-auto" data-id="element-158">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-16" data-id="element-159">
            <h2 className="md:text-5xl font-bold mb-6 font-[Poppins,_sans-serif] text-[24px]" data-id="element-160">
              ¿Cuántos años más vas a "adivinar" qué le pasa a tu panza?
            </h2>
          </motion.div>

          <div className="grid gap-4 md:gap-6 mb-16" data-id="element-161">
            {points.map((point, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-start gap-4 bg-[#2a0a0a] p-5 rounded-xl border border-red-900/80" data-id="element-162">
                <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-163" />
                <p className="text-gray-200 text-[17px]" data-id="element-164">{point}</p>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="text-center" data-id="element-165">
            <h3 className="text-2xl md:text-4xl font-bold text-brand-gold italic font-[Inter,_sans-serif]" data-id="element-166">
              El Mapa de Alivio Invisible conecta esos puntos por primera vez.
            </h3>
          </motion.div>
        </div>
      </div>
    </section>;
}